import React from 'react'
import createUserMutation from 'graphs/mutations/createUser.graphql'
import userValidation from 'validations/user'
import FormForRecord from 'components/FormForRecord'
import userFields from 'fields/users'

const RouteNew = ({ history: { goBack }, ...rest }) => (
  <FormForRecord
    mutation={createUserMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={userFields}
    schema={userValidation}
    title="Create A User"
    {...rest}
  />
)

export default RouteNew



// WEBPACK FOOTER //
// ./src/routes/admin/users/new.js